import { render } from "./LucidFeeds.vue?vue&type=template&id=208f62e7"
import script from "./LucidFeeds.vue?vue&type=script&lang=js"
export * from "./LucidFeeds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__